import { Model } from '@vuex-orm/core'
import User from './User'
import Questionnaire from './Questionnaire'

export default class Team extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'team'

  static primaryKey = '_id'

  // List of all fields (schema) of the model. `this.attr` is used for the generic field type.
  // The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      title: this.attr(''),
      owner: this.attr({}),
      visibility: this.attr('')
    }
  }

  static apiConfig = {}
}

export class TeamProfile extends Team {
  static entity = 'team_profile'

  static fields () {
    return {
      ...super.fields(),
      leaders: this.hasMany(Leader, '_id'),
      members: this.hasMany(Member, '_id'),
      tags: this.attr([]),
      questionnaires: this.hasMany(Questionnaire, '_id'),
      childTeams: this.attr([])
    }
  }
}

class Leader extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'leader'

  static primaryKey = '_id'

  // List of all fields (schema) of the model. `this.attr` is used for the generic field type.
  // The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      user: this.hasOne(User, '_id',),
      createSubteam: this.attr(false),
      subteamAlreadyCreated: this.attr(false),
      subteamName: this.attr(''),
      createdAt: this.attr('')
    }
  }
}

class Member extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'member'

  static primaryKey = '_id'

  // List of all fields (schema) of the model. `this.attr` is used for the generic field type.
  // The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      user: this.hasOne(User, '_id'),
      createdAt: this.attr('')
    }
  }
}